import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import SupportiveMessage, {
  SupportiveMessageColor,
} from '@lib/components/SupportiveMessage/SupportiveMessage';
import validateLegendRanges from '../utils/validateLegendRanges';
import styles from '../MonitoringFilter/MonitoringFilter.module.scss';

export default function LegendFormErrors() {
  const { t } = useTranslation();
  const { getValues } = useFormContext();
  const values = getValues();

  const errorText = validateLegendRanges(values.items || [], t);

  if (!errorText) return null;

  return (
    <div className={styles.totalError}>
      <SupportiveMessage text={errorText} color={SupportiveMessageColor.Red} />
    </div>
  );
}
